import { useOutletContext } from "react-router-dom";
import Navbar from "../../../../core/components/navbar/navbar";
import SurveyList from "../components/survey_list";
import { UserInterface } from "../../../../core/components/user/domain/interfaces/user_interface";
import { useTranslation } from "../../../../i18n/useTranslation";
import PartnersSection from "../../../../core/components/partners_section";

const SurveyPage: React.FC = () => {
    const { t } = useTranslation();
    const { company } = useOutletContext<UserInterface>()
    return (
        <div className="min-h-dvh flex flex-col items-center px-3 pt-[6.9dvh] pb-25 gap-10.5">
            <div className="flex flex-col items-center gap-3">
                {company && company.picture && company.permissions.whiteLabel === true && <img src={company.picture} alt={t('common.logo_alt', { name: company.name })} className={`h-18 w-auto rounded-xl`}/>}
                <div className="flex flex-col items-center gap-1.5">
                    <h1 className="font-bold text-[25px] text-center">{t('survey.title')}</h1>
                    <p className="text-xs text-center" style={{ color: '#494949' }}>{t('survey.subtitle')}</p>
                </div>
            </div>

            <SurveyList/>

            <PartnersSection/>

            <div className='fixed bottom-6 flex w-full px-3 justify-center'>
                <Navbar/>
            </div>
        </div>
    );
}

export default SurveyPage;